import React, { useState } from "react";
import { FormGroup, Label, Col } from "reactstrap";

export const SafeArtistImage = ({ src, alt, style, className }) => {
  const [imageError, setImageError] = useState(false);

  if (!src || imageError) {
    return null;
  }

  return (
    <img
      src={src}
      alt={alt}
      style={style}
      className={className}
      onError={() => setImageError(true)}
    />
  );
};

const StoreArtistFormImage = ({ label, src, alt }) => {
  const [imageError, setImageError] = useState(false);

  if (!src || imageError) {
    return null;
  }

  return (
    <FormGroup row>
      <Label sm={2}>{label}</Label>
      <Col xs={2}>
        <img
          src={src}
          style={{ width: "150px", padding: "10px 0" }}
          alt={alt}
          onError={() => setImageError(true)}
        />
      </Col>
    </FormGroup>
  );
};

export default StoreArtistFormImage;
